// extracted by mini-css-extract-plugin
export default {"container":"copy_legislation_button-module__container--2shG8","icon":"copy_legislation_button-module__icon--1wRUh","link":"copy_legislation_button-module__link--3FX4d"};